export const postToAPI = async (route, data, accessToken, isFile) => {
  try {
    const res = await fetch(`https://soundbasket-serverless.vercel.app/api/${route}`, {
      method: "POST",
      headers: {
        auth: `Bearer ${accessToken}`
      },
      body: isFile ? data : JSON.stringify(data),
    });
    const json = await res.json();
    return json;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getFromApi = async (route, accessToken) => {
  try {
    const headers = {
      "Content-Type": "application/json", 
      "Authorization": accessToken ? `Bearer ${accessToken}` : null
    };        
    const res = await fetch(`https://soundbasket-serverless.vercel.app/api/${route}`, {
      headers
    });
    const json = await res.json();
    return json;
  } catch (error) {
    console.log(error)
    throw error;
  }
}